import { TippingOrderApi } from '../../generated/api';
import configuration from './configuration';

const tippingOrder = new TippingOrderApi(configuration);

export default tippingOrder;
